<template>
    <button
        :type="nativeType"
        :disabled="disabled"
        :class="buttonClass"
        @click="onClick"
    >
        <slot/>
    </button>
</template>

<script>
const typeMap = {
    default: 'btn-default',
    primary: 'btn-primary',
    danger: 'btn-danger',
    success: 'btn-success',
    info: 'btn-default',
    warning: 'btn-default'
}

const sizeMap = {
    xs: 'btn-xs',
    sm: 'btn-sm',
    lg: ''
}

export default {
    name: 'BBtn',
    inheritAttrs: true,
    emits: ['click'],
    props: {
        type: {
            type: String,
            default: 'default'
        },
        variant: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        nativeType: {
            type: String,
            default: 'button'
        }
    },
    computed: {
        buttonClass () {
            const tone = this.variant || this.type || 'default'
            return [
                'btn',
                typeMap[tone] || 'btn-default',
                this.size ? sizeMap[this.size] : null,
                { 'opacity-50 cursor-not-allowed': this.disabled }
            ]
        }
    },
    methods: {
        onClick (event) {
            if (this.disabled) {
                event.preventDefault()
                event.stopPropagation()
                return
            }
            this.$emit('click', event)
        }
    }
}
</script>
